import { useQueryState } from 'nuqs'
import { useMemo } from 'react'

export function useAuditTrailQueryParams() {
  const [audit] = useQueryState('audit')
  return useMemo(
    () => ({
      ...(audit ? { audit: 'true' } : {}),
    }),
    [audit],
  )
}
